import { css } from 'styled-components';

// screen size for responsiveness
export const screenSizes = {
  xxs: 0,
  xs: 375,
  sm: 428,
  md: 743,
  lg: 1023,
  xl: 1280,
  xlr: 1440,
  xxl: 1680,
  vxxl: 1920,
};

const mediaQueries = {
  xxs: `(min-width: ${screenSizes.xxs}px)`,
  xs: `(min-width: ${screenSizes.xs}px)`,
  sm: `(min-width: ${screenSizes.sm}px)`,
  md: `(min-width: ${screenSizes.md}px)`,
  lg: `(min-width: ${screenSizes.lg}px)`,
  xl: `(min-width: ${screenSizes.xl}px)`,
  xlr: `(min-width: ${screenSizes.xlr}px)`,
  xxl: `(min-width: ${screenSizes.xxl}px)`,
  vxxl: `(min-width: ${screenSizes.vxxl}px)`,
};

export const media = Object.keys(mediaQueries).reduce((acc, segment) => {
  const styledMediaFunction = (...args) => css`
    @media ${mediaQueries[segment]} {
      ${css(...args)};
    }
  `;
  return {
    ...acc,
    [segment]: styledMediaFunction,
  };
}, {});
